/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () { 
    var windowsize = $(window).width();

    $(window).resize(function() {
      var windowsize = $(window).width();
    });

     $(document).on('click', 'a[href="#buy-now"]', function(e) {
        if (windowsize > 767) {
           if(window.location.href.indexOf('special-offer-fb')> -1){
            //e.preventDefault();
              setTimeout(function(){
                var newId = $('#s-31ca817f-f4ad-40fc-9e59-6ea7d0ae8e93');
                var newPos = newId.offset().top;
                $('body, html').animate({scrollTop: newPos});
              },100)
            }
        }
       
        //e.preventDefault();
        var id = $(this).attr('href');
        var $id = $(id);
        if ($id.length === 0) {
            return;
        }
       
        var pos = $id.offset().top;
        $('body, html').animate({scrollTop: pos});
       
    });
  



  if($(window).width() < 768) {

      $(window).on('scroll', function() {
        
        // https://tuski.co/pages/special-offer-fb
        var $elem = $("#s-6a850863-e95b-4978-a985-c2bfa267b841"); // First Item hide
        var $elem2 = $("#s-b2792f37-bc29-46fd-bba2-fe53b55349e9");// Second Item Show

      // https://tuski.co/pages/special-offer-fb-v1
        var $elem = $("#s-1f7eb579-c7f3-4911-9143-1ceb43440fde"); // First Item hide
        var $elem2 = $("#s-46e1492a-3a4d-4819-97a1-62f97f557996");// Second Item Show
        

        // https://tuski.co/pages/tuski-special-offer-fb
        if ($elem.length < 1 || $elem2.length < 1 ){
            
            $elem = $('div#s-3adad0a0-9b47-481f-be71-0dadb9c11349'); // First Item hide
            $elem2 = $('div#s-2205cf7f-0ec7-48b6-937d-8678d3db1095');// Second Item Show
        }

        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();
        var elemTop = $elem.offset().top;
        var elemTop2 = $elem2.offset().top;
        var elemBottom = elemTop + $elem.height();
        //console.log('hello',elemBottom,elemTop2, docViewBottom)
        if ((elemBottom < docViewBottom)) {
          $('.choose-keep-btn a').addClass("hide-btn");
          if(elemTop2 < docViewBottom){
            $('.choose-keep-btn a').removeClass("hide-btn");
          }
        } else {
          $('.choose-keep-btn a').removeClass("hide-btn");
        }
      });
    }
  
    
     if(window.location.href.indexOf('pages/special-offer') > -1){
     	$('body').addClass("special-offer");
     }
  
     if(window.location.href.indexOf('pages/6-reasons') > -1){
     	$('body').addClass("reasons");
     }
  
     if(window.location.href.indexOf('/pages/must-have-product-2021') > -1){
     	$('body').addClass("must-have-product");
     }
  
	if(window.location.href.indexOf('/pages/earlybird') > -1){
     	$('body').addClass("earlybird");
     }

 	if(window.location.href.indexOf('/pages/toothbrush-offer-fb') > -1){
     	$('body').addClass("toothbrush-offer-fb");
     }
      
 	if(window.location.href.indexOf('pages/special-offer-fb') > -1){
     	$('body').addClass("special-offer-fb");
     }

    if(window.location.href.indexOf('pages/special-offer-fb-v1') > -1){
     	$('body').addClass("special-offer-fb-v1");
     }
   
  
  $('.customATC').click(function(){
    fbq('track', 'AddToCart'); 
    //console.log('atc added') 
  }) 
        
});        


// Skip Cart and Quantity button

  $(document).ready(function () {
    

    var startingUrl,x1FlosserWhite,x1FlosserBlack,x2FlosserWhite,x2FlosserBlack,
          x1Whitex1Black,x3FlosserWhite,x3FlosserBlack,x1Whitex2Black,x2Whitex1Black,
          x4FlosserWhite, x4FlosserBlack, x1Whitex3Black,x2Whitex2Black,x3Whitex1Black,
          x1Fwhitex1Twhite, x1Fwhitex1Tblack, x1Fblackx1Twhite, x1Fblackx1Tblack,
          x2Fwhitex2Twhite, x2Fwhitex2Tblack, x2Fblackx2Twhite, x2Fblackx2Tblack,

        startingUrl = "/cart/";
        x1FlosserWhite = "39945279438999:1";
        x1FlosserBlack = "39945279471767:1";
        x2FlosserWhite = "39945278947479:1";
        x2FlosserBlack = "39945278980247:1";
        x1Whitex1Black = "39945279013015:1";
        x3FlosserWhite = "39945278619799:1";
        x3FlosserBlack = "39945278652567:1";
        x1Whitex2Black = "39945278685335:1";
        x2Whitex1Black = "39945278718103:1";
    	
    	x4FlosserWhite = "42611269763322:1";
        x4FlosserBlack = "42611269796090:1";
        x1Whitex3Black = "42611269828858:1";
        x2Whitex2Black = "43706691846394:1";
        x3Whitex1Black = "42611275890938:1";
    
    
     if(window.location.href.indexOf('special-offer-fb-v1')> -1){
        startingUrl = "/cart/";
        x1FlosserWhite = "39945279438999:1";
        x1FlosserBlack = "39945279471767:1";
        x2FlosserWhite = "39945278947479:1";
        x2FlosserBlack = "39945278980247:1";
        x1Whitex1Black = "39945279013015:1";
        x3FlosserWhite = "39945278619799:1";
        x3FlosserBlack = "39945278652567:1";
        x1Whitex2Black = "39945278685335:1";
        x2Whitex1Black = "39945278718103:1";
    	
    	x4FlosserWhite = "42611269763322:1";
        x4FlosserBlack = "42611269796090:1";
        x1Whitex3Black = "42611269828858:1";
        x2Whitex2Black = "43706691846394:1";
        x3Whitex1Black = "42611275890938:1";
      
        x1Fwhitex1Twhite = "42828775063802:1";
        x1Fwhitex1Tblack = "42828775096570:1";
        x1Fblackx1Twhite = "42828775129338:1";
        x1Fblackx1Tblack = "42828775162106:1";
        
        x2Fwhitex2Twhite = "42828756287738:1";
        x2Fwhitex2Tblack = "42828756353274:1";
        x2Fblackx2Twhite = "42828756451578:1";
        x2Fblackx2Tblack = "42828756386042:1";
    }


    
    if(window.location.href.indexOf('toothbrush-offer-fb')> -1){
        startingUrl = "/cart/";
        x1FlosserWhite = "42942439293178:1";
        x1FlosserBlack = "42942439325946:1";
        x2FlosserWhite = "42942440734970:1";
        x2FlosserBlack = "42942440767738:1";
        x1Whitex1Black = "42942440800506:1";
        x3FlosserWhite = "42942442045690:1";
        x3FlosserBlack = "42942442078458:1";
        x1Whitex2Black = "42942442111226:1";
        x2Whitex1Black = "42942442143994:1";
    }
    
    
    if(window.location.href.indexOf('toothbrush-offer-fb-v1')> -1){
        startingUrl = "/cart/";
        x1FlosserWhite = "42958526218490:1";
        x1FlosserBlack = "42958526251258:1";
        x2FlosserWhite = "42942440734970:1";
        x2FlosserBlack = "42942440767738:1";
        x1Whitex1Black = "42942440800506:1";
        x3FlosserWhite = "42942442045690:1";
        x3FlosserBlack = "42942442078458:1";
        x1Whitex2Black = "42942442111226:1";
        x2Whitex1Black = "42942442143994:1";
    }
    
    
    if(window.location.href.indexOf('special-offer-fb')> -1 
      || window.location.href.indexOf('toothbrush-offer-fb')> -1
      ){
      
     
      var selectedUrl1 = x1FlosserWhite;
      var selectedUrl2 = x2FlosserWhite;
      var selectedUrl3 = x3FlosserWhite;
      var selectedUrl4 = x4FlosserWhite;
      var selectedUrl5 = x1Fwhitex1Twhite;
      var selectedUrl6 = x2Fwhitex2Twhite;


      var anchorTag =
        '<a id="s-affc6d47-2daa-45cc-9bc7-f76740135302" class="shg-btn shg-cse customATC" href="#" >BUY NOW</a>';

      var x1Flosser =
        '<div class="quantity-btn x1"><button class="selected" data=' +
        x1FlosserWhite +
        ">1 x White</button><button data=" +
        x1FlosserBlack +
        ">1 x Black</button></div>";

      var x2Flosser =
        '<div class="quantity-btn x2"><button class="selected" data=' +
        x2FlosserWhite +
        ">2 x White</button><button data=" +
        x2FlosserBlack +
        ">2 x Black</button><button data=" +
        x1Whitex1Black +
        ">1 x White, 1 x Black</button></div>";

      var x3Flosser =
        '<div class="quantity-btn x3"><button class="selected" data=' +
        x3FlosserWhite +
        ">3 x White</button><button data=" +
        x3FlosserBlack +
        ">3 x Black</button><button data=" +
        x1Whitex2Black +
        ">1 x White, 2 x Black</button><button data=" +
        x2Whitex1Black +
        ">2 x White, 1 x Black</button></div>";
      
      var x4Flosser =
        '<div class="quantity-btn x4"><button class="selected" data=' +
        x4FlosserWhite +
        ">4 x White</button><button data=" +
        x4FlosserBlack +
        ">4 x Black</button><button data=" +
        x1Whitex3Black +
        ">1 x White, 3 x Black</button><button data=" +
        x2Whitex2Black +
        ">2 x White, 2 x Black</button><button data=" +
         x3Whitex1Black +
        ">3 x White, 1 x Black</button></div>";
      
      var x5FlosserT =
        '<div class="quantity-btn x5"><button class="selected" data=' +
        x1Fwhitex1Twhite +
        ">1 x White WF, 1 x White TB</button><button data=" +
        x1Fwhitex1Tblack +
        ">1 x White WF, 1 x Black TB</button><button data=" +
        x1Fblackx1Twhite +
        ">1 x Black WF, 1 x White TB</button><button data=" +
        x1Fblackx1Tblack +
        ">1 x Black WF, 1 x Black TB</button></div>";
      
      var x6FlosserT =
        '<div class="quantity-btn x6"><button class="selected" data=' +
        x2Fwhitex2Twhite +
        ">2 x White WF, 2 x White TB</button><button data=" +
        x2Fwhitex2Tblack +
        ">2 x White WF, 2 x Black TB</button><button data=" +
        x2Fblackx2Twhite +
        ">2 x Black WF, 2 x White TB</button><button data=" +
        x2Fblackx2Tblack +
        ">2 x Black WF, 2 x Black TB</button></div>";

      
      $("div#s-5be2b29d-9581-4135-b4f4-f17640e01f45, #s-45fa14a3-c5ec-4824-a31f-c22e32ff6f3c, #s-4d165239-f499-4e92-9650-606b1d37db58, #s-e728a7c6-65a2-4815-90a7-93627baba5e5, #s-9e69f55e-20f6-4605-9e16-11b40c712c47").before(x1Flosser);
      $("div#s-70b10ced-553c-4f7a-ad28-22080aee98b6, #s-cbc2ea37-3580-4b01-a747-8990ae1dfec4,#s-d76ccbfb-f571-44d2-954c-44734509e812, #s-0e9d0123-e5b2-443a-99b7-cafa29dc726a, #s-14cfa1d8-508f-4146-909b-25df5c3d7b66").before(x2Flosser);
      $("div#s-aaaea15d-8ebe-4180-bef5-dd985da23c5e, #s-7759fc2a-3935-4125-b339-0bdf324d8a2d,#s-041cda64-b54c-4df3-85d5-01b66747d222, #s-0fcdd134-04c1-41fe-bfd4-5d1f33248ff0, #s-8ef6a236-9f01-4b86-bb7a-a730340296ac").before(x3Flosser);
      $("#s-543e0d5e-ecbe-4810-a3ae-dec2cfd03d67, #s-94e91df3-87c1-48bc-b239-4f6d25c79cc5, #s-55aaeef9-6cb8-4115-a7bc-03fc4f437f2d, #s-88fc5ed7-8490-40cb-aac2-dfbe1b181c51").before(x4Flosser);

      $("div#s-df231b8d-eb6f-4384-947a-c961b7dde990, #s-2b9cccdd-1c30-4d62-a298-8198639c370a").before(x5FlosserT);
      $("div#s-ba703a50-c45d-4002-8e8e-52e857c3e9f0, #s-342f5c3a-9a14-450d-93a9-9218b8997e03").before(x6FlosserT);


      var formNew =
        '<form class="new-form shg-product-atc-btn-wrapper shg-align-center"></form>';


        $("form[action='/cart/add']").each(function () {
          $(this).css("display", "none").after(formNew);
        });



      $(".new-form").html(anchorTag);

      $(".quantity-btn button").each(function () {
        if ($(this).parent().hasClass("x1")) {
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl1);
          //splitter(selectedUrl1)
        } else if ($(this).parent().hasClass("x2")) {
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl2);
          //splitter(selectedUrl2)
        } else if ($(this).parent().hasClass("x3")) {
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl3);
          //splitter(selectedUrl3)
        } else if ($(this).parent().hasClass("x4")) {
            $(this)
              .parent()
              .parent()
              .find(".new-form a")
              .attr("href", startingUrl + selectedUrl4);
            //splitter(selectedUrl3)
          } else if ($(this).parent().hasClass("x5")) {
            $(this)
              .parent()
              .parent()
              .find(".new-form a")
              .attr("href", startingUrl + selectedUrl5);
            //splitter(selectedUrl3)
          }
          else {
              $(this)
              .parent()
              .parent()
              .find(".new-form a")
              .attr("href", startingUrl + selectedUrl6);
          }
      });

      $(".quantity-btn button").on("click", function () {
        var value = $(this).text();
        //console.log(value);
        $(this)
          .parent()
          .parent()
          .find("select option")
          .each(function () {
            console.log($(this).text());
            if ($(this).text() == value) {
              //console.log(value);
              
              if(window.location.href.indexOf('special-offer-fb')> -1){
                var start =
                  "https://cdn.shopify.com/s/files/1/0519/3328/2455/products/";
                //https://cdn.shopify.com/s/files/1/0519/3328/2455/products/1W_flosser_1W_toothbrush-min.png
                var middle = "";
                               
                if (value == "1 x White, 1 x Black") {
                  middle = "1W1B";
                } else if (value == "1 x White, 2 x Black") {
                  middle = "1W2B";
                } else if (value == "2 x White, 1 x Black") {
                  middle = "2W1B";
                } else if (value == "4 x White") {
                  middle = "4W-min";
                } else if (value == "4 x Black") {
                  middle = "4W-min-1";
                } else if (value == "1 x White, 3 x Black") {
                  middle = "1W3B-min";
                } else if (value == "2 x White, 2 x Black") {
                  middle = "2W2B-min";
                } else if (value == "3 x White, 1 x Black") {
                  middle = "3W1B-min";
                } else {
                  middle = value.replaceAll(/\s/g, "");
                }
                
                if(value == "1 x White WF, 1 x White TB"){
                   middle="1W_flosser_1W_toothbrush-min"
                } else if(value == "1 x White WF, 1 x Black TB"){
                   middle="1W_flosser_1B_toothbrush-min"
                } else if(value == "1 x Black WF, 1 x White TB"){
                   middle="1B_flosser_1W_toothbrush-min_1"
                } else if(value == "1 x Black WF, 1 x Black TB"){
                   middle="1B_flosser_1B_toothbrush-min"
                } else if(value == "2 x White WF, 2 x White TB"){
                   middle="TUSKI_2Wflossers2Wtoothbrush-min.png"
                } else if(value == "2 x White WF, 2 x Black TB"){
                  middle="TUSKI_2Wflossers2Btoothbrush-min.png"
                } else if(value == "2 x Black WF, 2 x White TB"){
                  middle="TUSKI_2Bflossers2Wtoothbrush-min.png"
                } else if(value == "2 x Black WF, 2 x Black TB"){
                  middle="TUSKI_2Bflossers2Btoothbrush-min.png"
                }
                
                var end = "_1296x.jpg";
                if(middle.indexOf('min')>-1){
                  end = "_1296x.png";
                }
                if(middle.indexOf('toothbrush-min')>-1){
                  end = ".png";
                }
  //               https://cdn.shopify.com/s/files/1/0519/3328/2455/products/4W-min_1296x.png

                var url = start + middle + end;
                console.log(value, url, middle);
              }
              
              if(window.location.href.indexOf('toothbrush-offer-fb')> -1){
              	 var start =
                "https://cdn.shopify.com/s/files/1/0519/3328/2455/products/";
                  var middle = "";
                  if (value == "1 x White") {
                    middle = "1W";
                  }
                  if (value == "1 x Black") {
                    middle = "1B";
                  }
                  if (value == "2 x White") {
                    middle = "2W-min";
                  }
                  if (value == "2 x Black") {
                    middle = "2B";
                  }
                  if (value == "1 x White, 1 x Black") {
                    middle = "1W1B";
                  }
                  if (value == "3 x White") {
                    middle = "3W-Best-Value-min";
                  }
                  if (value == "3 x Black") {
                    middle = "3B-Best-Value-min";
                  }
                  if (value == "1 x White, 2 x Black") {
                    middle = "2B-1-W-Best-value--min";
                  }
                  if (value == "2 x White, 1 x Black") {
                    middle = "2W-1-B-Best-Value--min";
                  }
                  var end = "-Toothbrush-min.png";
                  if(middle.indexOf('min')>-1){
                    end = ".png";
                  }
                  var url = start + middle + end;
              }
              
			
              $(this)
                .closest(".shg-c-lg-3")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("src", url);
              $(this)
                .closest(".shg-c-lg-3")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("srcset", url);
              $(this)
                .closest(".shg-c-lg-3")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("data-srcset", url);
              
              
              $(this)
                .closest(".shg-c-lg-4")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("src", url);
              $(this)
                .closest(".shg-c-lg-4")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("srcset", url);
              $(this)
                .closest(".shg-c-lg-4")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("data-srcset", url);
              
              $(this)
                .closest(".shg-c-xs-6")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("src", url);
              $(this)
                .closest(".shg-c-xs-6")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("srcset", url);
              $(this)
                .closest(".shg-c-xs-6")
                .find(".shg-product-image-wrapper img.shogun-image")
                .attr("data-srcset", url);
            }
          });
        //console.log(value);
        $(this).parent().find("button").removeClass("selected");
        $(this).addClass("selected");
        if ($(this).parent().hasClass("x1")) {
          selectedUrl1 = $(this).attr("data");
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl1);
          //splitter(selectedUrl1)
        } else if ($(this).parent().hasClass("x2")) {
          selectedUrl2 = $(this).attr("data");
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl2);
          //splitter(selectedUrl2)
         } else if ($(this).parent().hasClass("x3")) {
          selectedUrl3 = $(this).attr("data");
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl3);
          //splitter(selectedUrl3)
        } else {
          selectedUrl4 = $(this).attr("data");
          $(this)
            .parent()
            .parent()
            .find(".new-form a")
            .attr("href", startingUrl + selectedUrl4);
          //splitter(selectedUrl3)
        }
      });
    }  
  });




  
//   $.ajax({
//     url:"https://extreme-ip-lookup.com/json/",  
//     success:function(data) {
//       var countryText;
// 	  switch (data.country.toUpperCase()) {
// 		case 'UNITED STATES':
// 			countryText = "TODAY ONLY: FREE SHIPPING TO USA 🇺🇸";
// 			break;
// 	    case 'CANADA':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO CANADA 🇨🇦";
// 	    	break;
// 	    case 'AUSTRALIA':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO AUS 🇦🇺";
// 	    	break;
// 	    case 'NEW ZEALAND':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO NZ 🇳🇿";
// 	    	break;
// 	    case 'GERMANY':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO GERMANY 🇩🇪";
// 	    	break;
// 	    case 'FRANCE':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO FRANCE 🇫🇷";
// 	    	break;
// 	    case 'ITALY':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO ITALY 🇮🇹";
// 	    	break;
// 	    case 'SINGAPORE':
// 	    	countryText = "TODAY ONLY: FREE SHIPPING TO SINGAPORE 🇸🇬";
// 		break;	
//  	    default:
//  			countryText = "TODAY ONLY: FREE SHIPPING TO USA AND CANADA";
// 	    break;
// 	}
      	//$('p.AnnouncementBar__Content.Heading').addClass('show');
        //$('p.AnnouncementBar__Content.Heading').html(countryText);
      
		//$('#s-b7ea0a34-f01e-4e20-81a7-a073ec61ecd3 .shogun-heading-component h1 b').addClass('show');  
		//$('#s-b7ea0a34-f01e-4e20-81a7-a073ec61ecd3 .shogun-heading-component h1 b').html(countryText);
		//console.log(data.country, countryText); 
//     }
//   });